import type { AssignedQuizFilters } from '@repo/types/pagination';

import { cn } from '@repo/lib/cn';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle';
import { filterLabels } from '@/lib/quiz';
import { useCredentials } from '@/store/auth-store';

interface QuizzesFiltersContentProps {
  value?: string;
  onValueChange: (value?: AssignedQuizFilters) => void;
  className?: string;
}

export default function QuizzesFiltersContent(quizzesFiltersContentProps: QuizzesFiltersContentProps) {
  const { value, onValueChange, className } = quizzesFiltersContentProps;
  const { lvl } = useCredentials();

  const handleValueChange = (val: string) => {
    if (val === 'all') {
      onValueChange(undefined);
    } else {
      onValueChange(val as AssignedQuizFilters);
    }
  };

  return (
    <ToggleGroup type={'single'} variant={'outline'} value={value ?? 'all'} onValueChange={handleValueChange} groupVariant="separate" size="sm" className={cn('flex w-full flex-wrap', className)}>
      <ToggleGroupItem className="w-full text-xs sm:w-fit" value="all">
        Wszystkie
      </ToggleGroupItem>
      <ToggleGroupItem className="w-full text-xs sm:w-fit" value="available">
        {filterLabels.available}
      </ToggleGroupItem>
      <ToggleGroupItem className="w-full text-xs sm:w-fit" value="before">
        {filterLabels.before}
      </ToggleGroupItem>
      <ToggleGroupItem className="w-full text-xs sm:w-fit" value="past">
        {filterLabels.past}
      </ToggleGroupItem>
      {lvl == 0 && (
        <>
          <ToggleGroupItem className="w-full text-xs sm:w-fit" value="completed">
            {filterLabels.completed}
          </ToggleGroupItem>
          <ToggleGroupItem className="w-full text-xs sm:w-fit" value="notcompleted">
            {filterLabels.notcompleted}
          </ToggleGroupItem>
        </>
      )}
    </ToggleGroup>
  );
}
